import { render, staticRenderFns } from "./AddBook.vue?vue&type=template&id=fc0025fe&scoped=true"
import script from "./AddBook.vue?vue&type=script&lang=js"
export * from "./AddBook.vue?vue&type=script&lang=js"
import style0 from "./AddBook.vue?vue&type=style&index=0&id=fc0025fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc0025fe",
  null
  
)

export default component.exports